import numeral from 'numeral';

export const amountFormat = amount => {
  return numeral(amount).format('0,0');
};
